import VideoType from '../constants/video-type';

export const isImmersiveStream = (stream) => (
    stream.type === VideoType.IMMERSIVE_HLS_STEREO_LR ||
    stream.type === VideoType.IMMERSIVE_HLS_STEREO_TB ||
    stream.type === VideoType.IMMERSIVE_HLS_MONO ||
    stream.type === VideoType.IMMERSIVE_DASH_STEREO_TB ||
    stream.type === VideoType.IMMERSIVE_DASH_STEREO_LR ||
    stream.type === VideoType.IMMERSIVE_DASH_MONO
);

export default isImmersiveStream;



// WEBPACK FOOTER //
// ./src/js/util/is-immersive-stream.js